import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/tools/teams-administration/teams/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_layout/tools/teams-administration/teams/"!</div>
}
